import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { SideBarDeleteActionWithPopup } from '../../../../components/commons/SideBarComponents/DeleteActionWithPopup/sideBarDeleteActionWithPopup';
import {
  StyledContainerItems,
  StyledContainerFooterSideBar,
  StyledTitleSideBar,
  StyledContainerSimpleMethod
} from '../../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import Strings from '../../../../i18n';
import {
  useChangeEventsStatusMutation,
  useChangeEventStatusMutation,
  useDeleteMultipleEventsMutation
} from '../../../../services/events/eventService';
import { IEvent } from '../../../../types/events/eventsInterface';
import { ContainerButton } from '../addEvent/addEventStyles';
import { colors } from '../../../../constants/colors';

interface IEventDetailsProps {
  selectedEvents: IEvent[];
  setSelectedScenes: (scenes: IEvent[]) => void;
  setOpenSideBar: (openSideBar: boolean) => void;
  reloadTable: () => void;
}
export const MultipleEventsDetails = ({
  selectedEvents,
  setSelectedScenes,
  setOpenSideBar,
  reloadTable
}: IEventDetailsProps) => {
  const [deleteEv, { isSuccess: isSuccessDelete }] =
    useDeleteMultipleEventsMutation();

  const deleteEvent = () => {
    const ids = selectedEvents.reduce((acc: number[], event) => {
      return [...acc, event.eventId];
    }, []);
    deleteEv(ids);
  };
  const [
    changeEventsStatus,
    { isLoading: isLoadingChangeStatus, isSuccess: isSuccessChangeStatus }
  ] = useChangeEventsStatusMutation();
  useEffect(() => {
    if (isSuccessDelete) {
      setOpenSideBar(false);
      setSelectedScenes([]);
      toast.success(Strings.events.successDeleteEvent);
      reloadTable();
    }
  }, [isSuccessDelete]);

  useEffect(() => {
    if (isSuccessChangeStatus) {
      setOpenSideBar(false);
      setSelectedScenes([]);
      toast.success(Strings.events.eventStatusChangedSuccessfully);
      reloadTable();
    }
  }, [isSuccessChangeStatus]);

  const enableEvents = () => {
    const ids = selectedEvents.reduce((acc: number[], event) => {
      return [...acc, event.eventId];
    }, []);
    changeEventsStatus({ eventIds: ids, areEnabled: true });
  };

  const disableEvents = () => {
    const ids = selectedEvents.reduce((acc: number[], event) => {
      return [...acc, event.eventId];
    }, []);
    changeEventsStatus({ eventIds: ids, areEnabled: false });
  };
  return (
    <>
      {selectedEvents && (
        <>
          <StyledContainerItems>
            <StyledTitleSideBar>
              {Strings.events.multipleSelectedEvents}
            </StyledTitleSideBar>
            <SideBarDeleteActionWithPopup
              onDelete={() => deleteEvent()}
              titleConfirmation={Strings.events.deleteMultipleEventTitle}
              textConfirmation={Strings.common.thisActionIsIrreversible}
              textIcon={Strings.events.deleteEvent}
            />
          </StyledContainerItems>
          <ContainerButton>
            <StyledContainerSimpleMethod
              onClick={enableEvents}
              type="button"
              style={{ color: colors.black }}
            >
              {Strings.events.enableEvents}
            </StyledContainerSimpleMethod>
          </ContainerButton>

          <ContainerButton>
            <StyledContainerSimpleMethod
              type="button"
              onClick={disableEvents}
              style={{ color: colors.black }}
            >
              {Strings.events.disableEvents}
            </StyledContainerSimpleMethod>
          </ContainerButton>
          <StyledContainerFooterSideBar>
            <button
              type="button"
              className="btn-cancel"
              onClick={() => {
                setOpenSideBar(false);
                setSelectedScenes([]);
              }}
            >
              {Strings.common.cancel}
            </button>
          </StyledContainerFooterSideBar>
        </>
      )}
      <div />
    </>
  );
};
